import React from "react";
import { connect } from "react-redux";
import { setLoader } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";
import history from "../../history";
import DefaultAddressPopup from "../DefaultAddressPopup";

class AccountAddressInformationPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_default_address_popup: false,
      default_billing: false,
      default_shipping: false,
      addresses: [],
      defaultShippingAddress: null,
      defaultBillingAddress: null,
    };
  }

  componentDidMount = () => {
    // Load addresses from localStorage
    this.loadAddresses();
  };

  loadAddresses = () => {
    const addresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");
    const defaultShippingAddress = JSON.parse(localStorage.getItem("selectedShippingAddress") || "null");
    const defaultBillingAddress = JSON.parse(localStorage.getItem("billingAddress") || "null");

    this.setState({
      addresses,
      defaultShippingAddress: defaultShippingAddress || (addresses.length > 0 ? addresses[0] : null),
      defaultBillingAddress: defaultBillingAddress || defaultShippingAddress || (addresses.length > 0 ? addresses[0] : null),
    });
  };

  renderBillingAddress = () => {
    const billingAddress = this.state.defaultBillingAddress;

    if (billingAddress) {
      const street = Array.isArray(billingAddress.street) ? billingAddress.street[0] : billingAddress.street;
      const regionCode = billingAddress.region_code || billingAddress.regionCode || billingAddress.region?.region_code || '';

      return (
        <div style={{ position: "relative" }}>
          <div>
            {billingAddress.firstname} {billingAddress.lastname}
          </div>
          {billingAddress.telephone && <div>tel: {billingAddress.telephone}</div>}
          {street && <div>{street}</div>}
          <div>
            {billingAddress.city} {regionCode} {billingAddress.postcode}
          </div>
          <button
            type="button"
            style={{
              position: "absolute",
              top: 18,
              right: 0,
              background: "#bfdd00",
              color: "#022a1e",
              borderRadius: 20,
              width: 100,
            }}
            onClick={() => {
              this.setState({
                show_default_address_popup: true,
                default_billing: true,
                default_shipping: false,
              });
            }}
          >
            Edit
          </button>
        </div>
      );
    } else {
      return <div className="text-muted">No billing address saved</div>;
    }
  };

  renderDefaultShippingAddress = () => {
    const shippingAddress = this.state.defaultShippingAddress;

    if (shippingAddress) {
      const street = Array.isArray(shippingAddress.street) ? shippingAddress.street[0] : shippingAddress.street;
      const regionCode = shippingAddress.region_code || shippingAddress.regionCode || shippingAddress.region?.region_code || '';

      return (
        <div style={{ position: "relative" }}>
          <div>
            {shippingAddress.firstname} {shippingAddress.lastname}
          </div>
          {shippingAddress.telephone && <div>tel: {shippingAddress.telephone}</div>}
          {street && <div>{street}</div>}
          <div>
            {shippingAddress.city} {regionCode} {shippingAddress.postcode}
          </div>
          <button
            type="button"
            style={{
              position: "absolute",
              top: 18,
              right: 0,
              background: "#bfdd00",
              color: "#022a1e",
              borderRadius: 20,
              width: 100,
            }}
            onClick={() => {
              this.setState({
                show_default_address_popup: true,
                default_billing: false,
                default_shipping: true,
              });
            }}
          >
            Edit
          </button>
        </div>
      );
    } else {
      return <div className="text-muted">No default shipping address</div>;
    }
  };

  renderShippingAddresses = () => {
    const addresses = this.state.addresses;

    if (addresses.length > 0) {
      return addresses.map((v, index) => {
        const street = Array.isArray(v.street) ? v.street[0] : v.street;
        const regionCode = v.region_code || v.regionCode || v.region?.region_code || '';

        return (
          <div key={v.id || index} className="account-shipping-address">
            <div>
              {v.firstname} {v.lastname}
            </div>
            {v.telephone && <div>tel: {v.telephone}</div>}
            {street && <div>{street}</div>}
            <div>
              {v.city} {regionCode} {v.postcode}
            </div>
          </div>
        );
      });
    } else {
      return <div className="text-muted">No saved addresses</div>;
    }
  };

  render() {
    return (
      <div id="page-account-address-information">
        <AccountNav />
        <div id="account-content">
          <h1 className="h1">Address Information</h1>
          <div id="add-new-address-parent">
            <button
              type="button"
              id="add-new-address-button"
              onClick={() => {
                history.push(`/account/addaddress`);
              }}
            >
              Add New Address
            </button>
          </div>
          <h2 className="h2">Billing Address</h2>
          <div>{this.renderBillingAddress()}</div>
          <h2 className="h2">Default Shipping Address</h2>
          <div>{this.renderDefaultShippingAddress()}</div>
          <h2 className="h2">All Shipping Addresses</h2>
          <div id="account-all-shipping-addresses">
            {this.renderShippingAddresses()}
          </div>
        </div>
        {this.state.show_default_address_popup && (
          <DefaultAddressPopup
            addresses={this.state.addresses}
            billing={this.state.default_billing}
            shipping={this.state.default_shipping}
            onClickMask={() => {
              this.setState({ show_default_address_popup: false });
              this.loadAddresses(); // Reload addresses after popup closes
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default requireAuth(
  connect(mapStateToProps, { setLoader })(
    AccountAddressInformationPage
  )
);
